var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qr-generator",attrs:{"id":"qrTag"}},[_c('vue-qr',{ref:"qrTag",staticClass:"qrTag",attrs:{"size":500,"text":_vm.qrValue}}),_c('button',{staticClass:"qr-generator__print",attrs:{"type":"button","title":"پرینت QR"},on:{"click":function($event){return _vm.printImage()}}},[_c('b-icon-printer'),_c('span',[_vm._v("پرینت")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }